<template>
  <main class="mt-0 main-content">
    <ToastPrime position="bottom-left"/>
    <section>
      <div class="page-header min-vh-100">
        <div class="container-fluid px-0">
          <div class="row g-0">
            <div
              class="col-6 d-lg-flex d-none h-100 my-auto ps-0 position-absolute top-0 start-0 text-center justify-content-center flex-column">
              <div
                class="position-relative h-100 m-3 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${apiUrl + '/gambar_login.jpg'})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }">
                <span class="mask bg-gradient-primary opacity-6"></span>

                <div class="position-relative z-index-1">
                  <h4 class="mt-5 text-white font-weight-bolder">
                    "Recover Your Access"
                  </h4>
                  <p class="text-white px-5">
                    Jangan khawatir, tim SmartCat siap membantu Anda memulihkan akses ke dashboard inventaris Anda dengan cepat dan aman.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 offset-lg-6 d-flex align-items-center justify-content-center min-vh-100">
              <div class="card card-plain login-card shadow-lg bg-white">
                <div class="card-header pb-0 text-start bg-transparent border-0">
                  <h4 class="font-weight-bolder text-primary">Forgot Password</h4>
                  <p class="mb-0">Enter your email address to reset your password</p>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <input
v-model="email" type="email" placeholder="Email Address"
                      class="form-control" :class="`${errorMessage.email != '' ? 'border-danger' : ''}`"
                      :disabled="onLoading" @keyup="inputVal('email')"
                      @keyup.enter="sendResetEmail" />
                  </div>
                  <div class="text-center">
                    <argon-button
class="mt-4" variant="gradient" color="primary" full-width size="lg"
                      :disabled="onLoading" @click="sendResetEmail">
                      <span v-if="onLoading">
                        <i class="fas fa-spinner fa-spin"></i>&nbsp;Please wait
                      </span>
                      <span v-else>Send Reset Link</span>
                    </argon-button>
                  </div>
                  <div class="text-center mt-3">
                    <a href="/login" class="text-decoration-none">
                      <small class="text-muted">Back to Sign In</small>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import baseApiUrl from "@/configs/config";
import authService from "@/services/authService";
import api from "@/helpers/api";

const body = document.getElementsByTagName("body")[0];
body.classList.remove("bg-gray-100");

export default {
  components: {
    ArgonButton,
  },
  data() {
    return {
      email: "",
      apiUrl: baseApiUrl.storageUrl,
      errorMessage: {
        email: "",
        both: ""
      },
      successMessage: "",
      onLoading: false,
    };
  },
  mounted() {
    this.$store.commit("argonConfig/toggleDefaultLayout");
  },
  methods: {
    async sendResetEmail() {
      // Reset messages
      this.errorMessage = {
        email: "",
        both: ""
      };
      this.successMessage = "";

      // Validate email
      if (this.email.trim() === "") {
        this.errorMessage.email = "Email is required";
        return false;
      }

      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email.trim())) {
        this.errorMessage.email = "Please enter a valid email address";
        return false;
      }

      this.onLoading = true;

      try {
        await api(this, authService.forgotPassword({ email: this.email }), true);
        // this.successMessage = "Reset link sent to your email address.";
        this.email = ""; // Clear email input
      } catch (error) {
        console.error('Forgot password error:', error);
        if (error.response && error.response.data && error.response.data.message) {
          this.errorMessage.both = error.response.data.message;
        } else if (error.message) {
          this.errorMessage.both = error.message;
        } else {
          this.errorMessage.both = "An error occurred while sending the reset link.";
        }
      } finally {
        this.onLoading = false;
      }
    },

    inputVal(val) {
      if (val === "email") {
        this.errorMessage.email = "";
        // Clear both error if email is valid
        if (this.email.trim() !== "" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim())) {
          this.errorMessage.both = "";
        }
      }

      // Clear success message when user starts typing
      if (this.successMessage) {
        this.successMessage = "";
      }
    },
  },
};
</script>

<style scoped>
.login-card {
  background: white !important;
  border-radius: 1.25rem !important;
  width: 100%;
  max-width: 520px;
  padding: 2.5rem 2rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05) !important;
}

.form-control {
  padding: 0.75rem 1rem;
}
</style> 